export default __webpack_public_path__ + "static/media/crossCloseIcon.574b7c73.svg";